/**
 * 세금계산서 발행요청 링크 (/m/tax/{token}) — [사업자등록증 보기] 확대.
 * 이미지 주소는 버튼 data-zoom-src (본사에 따라 컨트롤러가 고른다).
 */
export default class TaxLink {
    initialize() {
        $(document).on('click', '.b-biz[data-zoom-src]', (e) => {
            $j.Ui.ZoomPhoto.open($(e.currentTarget).data('zoom-src'), {topNotice: '👉 사진을 3초간 꾹 누르면 내 휴대폰에 저장할 수 있습니다.'});
        });
    }
}
